import { useIntl } from "react-intl";

const useValidationMessages = () => {
  const intl = useIntl();

  const tooShortName = intl.formatMessage({
    defaultMessage: "För kort, ange minst 2 tecken",
  });

  const tooShortPassword = intl.formatMessage({
    defaultMessage: "För kort, ange minst 8 tecken",
  });

  const required = intl.formatMessage({
    defaultMessage: "Obligatoriskt fält",
  });

  const invalidEmailAddress = intl.formatMessage({
    defaultMessage: "Ogiltig e-postadress",
  });

  return {
    tooShortName,
    tooShortPassword,
    required,
    invalidEmailAddress,
  };
};

export default useValidationMessages;
